// extracted by mini-css-extract-plugin
module.exports = {"page":"Reimbursement_page__3AO8a","tabs":"Reimbursement_tabs__QL85y","tabSkeleton":"Reimbursement_tabSkeleton__1jneT"};